module.exports = __webpack_public_path__ + "static/escrow-cef26f7a1d567fc9ea60cf957d03b2b1.png";